import React from 'react';
import './Compere.css';

function Compere() {
  return (
    <div className="compere-container">
      <div className="compere-content">
        <h1>Compere</h1>
        <p className="coming-soon">This section is under development</p>
      </div>
    </div>
  );
}

export default Compere;
